module.exports = __webpack_public_path__ + "img/stairwell-small.d296e36f.png";